(function () {
  const mediaQuery = window.matchMedia('(min-width: 1025px)');
  let enabled = mediaQuery.matches;
  let images = [];
  let currentIndex = 0;
  function isProSlideImage(img) {
    return !!img.closest('[data-class="pro-slide-replo"]');
  }
  function canOpenModal(img) {
    return enabled || isProSlideImage(img);
  }
  function isValidImage(img) {
    return (
      img &&
      img.tagName === 'IMG' &&
      img.src &&
      img.closest('[data-class*="replo"], .product, .media, .gallery')
    );
  }
  function collectImages() {
    const imgs = Array.from(document.querySelectorAll('img[src]')).filter(
      img => img.complete && img.naturalWidth >= 300 && isValidImage(img)
    );
    images = [...new Set(imgs.map(img => img.src))];
  }

  function openModal(index) {
    collectImages();
    if (!images[index]) return;
    if (document.querySelector('#replo-image-modal')) return;
    currentIndex = index;
    const modal = document.createElement('div');
    modal.id = 'replo-image-modal';
    modal.innerHTML = `
      <div class="replo-modal-backdrop"></div>
      <div class="replo-modal-content">
        <button class="replo-modal-close">&times;</button>
        <button class="replo-modal-prev">&#10094;</button>
        <div class="replo-modal-main">
          <img class="replo-modal-main-image" src="${images[currentIndex]}" alt="Product image ${currentIndex + 1}" />
        </div>
        <button class="replo-modal-next">&#10095;</button>
        <div class="replo-modal-thumbs">
          ${images.map((src, i) => `
           <img src="${src}" alt="Product thumbnail ${i + 1}" data-index="${i}" class="replo-thumb ${i === currentIndex ? 'active' : ''}" />
          `).join('')}
        </div>
      </div>
    `;
    document.body.appendChild(modal);
    modal.querySelector('.replo-modal-close').onclick = closeModal;
    modal.querySelector('.replo-modal-backdrop').onclick = closeModal;
    modal.querySelector('.replo-modal-prev').onclick = prevImage;
    modal.querySelector('.replo-modal-next').onclick = nextImage;
    modal.querySelectorAll('.replo-thumb').forEach(t => {
      t.onclick = () => setActiveImage(+t.dataset.index);
    });
    document.addEventListener('keydown', keyHandler);
  }
  function closeModal() {
    document.querySelector('#replo-image-modal')?.remove();
    document.removeEventListener('keydown', keyHandler);
  }
  function setActiveImage(index) {
    if (!images[index]) return;
    currentIndex = index;
    document.querySelector('.replo-modal-main-image').src = images[index];
    document.querySelectorAll('.replo-thumb')
      .forEach((t, i) => t.classList.toggle('active', i === index));
  }
  function nextImage() {
    setActiveImage((currentIndex + 1) % images.length);
  }
  function prevImage() {
    setActiveImage((currentIndex - 1 + images.length) % images.length);
  }
  function keyHandler(e) {
    if (e.key === 'Escape') closeModal();
    if (e.key === 'ArrowRight') nextImage();
    if (e.key === 'ArrowLeft') prevImage();
  }
  document.addEventListener(
    'click',
    function (e) {
      const img = e.target.closest('img');
      if (!isValidImage(img)) return;
      if (!canOpenModal(img)) return;
      e.preventDefault();
      e.stopPropagation();
      if (!img.complete) {
        img.onload = () => {
          handleImageClick(img);
        };
        return;
      }
      handleImageClick(img);
    },
    true
  );
  function handleImageClick(img) {
    collectImages();
    let index = images.indexOf(img.src);
    if (index === -1) {
      images.unshift(img.src);
      index = 0;
    }
    openModal(index);
  }
  mediaQuery.addEventListener('change', e => {
    enabled = e.matches;
    if (!enabled) closeModal();
  });
})();